import type { TailwindPattern } from "../interface";

const containerPattern: TailwindPattern = {
    base: /container/,
};

export default containerPattern;

export const containerSample = [["container"]];
